import { Component, Input, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ModalShareComponent } from '../measure-card/modal-share/modal-share.component';

@Component({
  selector: 'lifedi-research-card',
  templateUrl: './research-card.component.html',
  styleUrls: ['./research-card.component.scss']
})
export class ResearchCardComponent implements OnInit {
  @Input() data;

  progress: number;

  constructor(
    public matDialog: MatDialog,
  ) { }

  ngOnInit(): void {
    // console.log(this.data);
    this.progress = (this.data.PROGRESS.done / this.data.PROGRESS.sum_measureOfResearch) * 100;
  }

  share() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = 'modalRegister';
    dialogConfig.width = '550px';
    dialogConfig.autoFocus = false;

    dialogConfig.data = {
      title: 'Share',
      actionBtnText: 'ปิด',
      link: this.data.LINK
    }

    const modal = this.matDialog.open(ModalShareComponent, dialogConfig);
    modal.afterClosed().subscribe()
  }

  openDetail() {
    if (!this.data.PROGRESS.status_sceen) {
      window.open('/research/research-screen-question?research_id=' + this.data.RESEARCH_ID, '_blank');

    } else if (this.data.PROGRESS.status_consent && this.data.PROGRESS.status_sceen) {
      window.open('/research/research-detail?research_id=' + this.data.RESEARCH_ID, '_blank');
    }

  }

  openConsent() {
    window.open('/research/research-consent?research_id=' + this.data.RESEARCH_ID + '&INVITER=' + '', '_blank');
  }


}
